export const startDate = new Date('2022-09-01');
